module.exports = __webpack_public_path__ + "img/getyhq_top.4f53a756.png";